export var getPlugin = function (_a) {
    var plugins = _a.plugins, methodName = _a.methodName;
    for (var pluginKey in plugins) {
        var key = pluginKey;
        if (new plugins[key]({ chainId: '1' }).method === methodName) {
            return plugins[key];
        }
    }
    return;
};
